import React from "react";
import { Link, useNavigate } from "react-router-dom";
import CloseSideMenuIcon from "../../assets/images/CloseSideMenuIcon";
import NeedHelpIcon from "../../assets/images/NeedHelpIcon";
import OpenSideMenuIcon from "../../assets/images/OpenSideMenuIcon";
import { Constants, MenuItemsPath } from "../../constants/constants";
import Button from "./cta/Button";
import PopupModal from "./PopupModal";
import ProfileImage from "../../assets/images/profile.svg";


export interface SideMenuWebProps {
  menuItems: string[];
  menuRef: React.RefObject<HTMLDivElement>;
  openModal: () => void;
  closeSlider: () => void;
  openSlider: ()=> void;
  closeModal: ()=> void;
  handleChange: (index:number)=> void;
  componentMap: Record<string, React.ComponentType<any>>;
  selectedMenuIndex: number;
  isSlideerOpen: boolean;
  isModalOpen: boolean;
}

const SideMenuWeb: React.FC<SideMenuWebProps> = ({
  menuItems,
  menuRef,
  componentMap,
  selectedMenuIndex,
  openModal,
  closeModal,
  isSlideerOpen,
  openSlider,
  closeSlider,
  handleChange,
  isModalOpen
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-primary h-full">
      <div className="flex items-center justify-between pl-3 h-20">
        <img
          className=" transition-all"
          height={!isSlideerOpen ? "31px" : "48px"}
          width={!isSlideerOpen ? "48px" : "73.5px"}
          alt="ProfileImg"
          src={ProfileImage}
        />
        <div className="z-10  transition-all cursor-pointer">
          {isSlideerOpen ? (
            <div
              onClick={closeSlider}
            >
              <CloseSideMenuIcon />
            </div>
          ) : (
            <div
              onClick={openSlider}
              className="mr-[-12px]"
            >
              <OpenSideMenuIcon />
            </div>
          )}
        </div>
      </div>
      <div ref={menuRef} className="sidenav">
        <div className="h-[760px] mt-100 w-64 rounded-b-lg">
          {menuItems.map((ele: string, index: number) => {
            const DynamicComponent = componentMap[ele];
            const color = selectedMenuIndex === index ? "#183883" : "white";
            return (
              <>
                {/* <Link to={MenuItemsPath[index]}> */}
                  <div
                    className={
                      index === 6
                        ? "mt-14 pt-14 border-t border-dashedLine border-dashed "
                        : ""
                    }
                  >
                    <div
                      onClick={() => handleChange(index)}
                      className={
                        selectedMenuIndex === index
                          ? "selectedSideMenu bg-sideMenubackground text-primary  flex items-center h-[60px] cursor-pointer"
                          : "unSelectedSideMenu text-white flex  items-center h-[60px] cursor-pointer"
                      }
                    >
                      <div className="w-[5px] h-10 bg-primary rounded-r-xl ml-[-1px]"></div>
                      {DynamicComponent && <DynamicComponent color={color} />}
                      {ele}
                    </div>
                  </div>
                {/* </Link> */}
              </>
            );
          })}
          {!isSlideerOpen ? (
            <div className="ml-5 transition-all bg-needHelp h-10 w-10 rounded-full flex justify-center items-center mt-16">
              <NeedHelpIcon />
            </div>
          ) : (
            <div className="bg-whiteColor transition-colors  ml-6 text-black flex flex-col justify-center items-center rounded-lg mt-16 h-[125px]  w-[204px]">
              <div className=" bg-needHelp   h-10 w-10 rounded-full flex justify-center items-center mt-[-45px]">
                <NeedHelpIcon />
              </div>
              <div>{Constants.help}</div>
              <div>
                <Button
                  handleClick={() => {
                    openModal();
                  }}
                  buttonText={Constants.seeTutorial}
                  className="focus:ring-4 focus:ring-gray-300 transition duration-300 bg-primary mt-4  text-white  py-2 px-11 rounded-md hover:bg-whiteColor hover:text-primary"
                />
              </div>
            </div>
          )}
          <PopupModal
            buttonText="Close"
            popUpMsg="Coming Sooon .."
            popUpTitle="Tutorial"
            isOpen={isModalOpen}
            onClose={closeModal}
            icon=""
          />
        </div>
      </div>
    </div>
  );
};

export default SideMenuWeb;
